import React from "react";
import Loadable from "../../react-loadable";
import "./index.less";

const WeaButtonIcon = Loadable({
  loader: () => import("./ButtonIcon"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaButtonIcon;



// WEBPACK FOOTER //
// ./ecology9/wea-button-icon/index.js